import { render, staticRenderFns } from "./MockTable.vue?vue&type=template&id=0cfd6440&scoped=true&"
import script from "./MockTable.vue?vue&type=script&lang=js&"
export * from "./MockTable.vue?vue&type=script&lang=js&"
import style0 from "./MockTable.vue?vue&type=style&index=0&id=0cfd6440&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cfd6440",
  null
  
)

export default component.exports